export default __webpack_public_path__ + "static/O0192-c82daff31c647de6d42ffcb6de56416d.png";